<app-service-settings-common
    [hideCustomCardNameInput]="true"
    [hideShareWithOtherServicesInput]="true"
    [title]="'service.settings.dashboard.header'"
>
    <ng-template #additionalContent>
        <p-divider></p-divider>
        @for (key of allowedWidgets(); track key) {
            <div class="dashboard-widget-setting">
                <app-check-input
                    [id]="key"
                    [form]="form"
                    [label]="'service.settings.dashboard.fields.' + key"
                ></app-check-input>
                @if (key === anamnesisWidgetKey && form.controls.anamnesis.value) {
                    <div class="flex-column gap pt-3 pl-5">
                        @for (field of anamnesisFields; track field) {
                            <app-check-input
                                [id]="field"
                                [form]="form.controls.anamnesisFields"
                                [label]="'service.settings.dashboard.anamnesisFields.' + field"
                            ></app-check-input>
                        }
                    </div>
                }
            </div>
        }
    </ng-template>
    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            (secondaryClickEvent)="cancel()"
        ></app-action-buttons>
    </ng-template>
</app-service-settings-common>
